// extracted by mini-css-extract-plugin
export default {"nowtime":"index_nowtime_it6Ny","nowdatetime":"index_nowdatetime_Ffcae","nextupdatetime":"index_nextupdatetime_arOWA","nexthour":"index_nexthour_T1kG-","time":"index_time_wD4A8"};